module.exports = {
  '@primary-color': '#F37243',
      '@link-color': '#ed939f',
      '@redMain': '#F37243',
      '@greyDark': '#454545',
};
